import React from 'react';
import { withStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';

import BackButton from "../../components/back_button.js";

const styles = theme => ({
  row: {
    minHeight: '30px',
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {

  },
  title: {
    fontSize: "21px",
    fontWeight: theme.typography.fontWeightBold
  },
  subtitle: {
    fontSize: "16px",
    color: theme.palette.grayText
  },
  backButton: {
    marginRight: "5px"
  },
  leftSpacing: {
    flexBasis: "33px",
    flexGrow: "0"
  },
  flexGrow: {
    flexGrow: 1
  },
  buttonsContainer: {
    display: "flex",
  }
});

class InfoPageHeader extends React.Component {

  render() {
    const { title, subtitle, classes, children } = this.props;

    return <div className = { classes.root } >
      <div className = { classes.row }>
        <BackButton className = { classes.backButton } />
        <div className = { classes.titleContainer } >
          <Typography variant = { "h1" }
                      className = { classes.title } >
            { title } 
          </Typography>
          <div className = { classes.subtitle } >
            { subtitle }
          </div>
        </div>
        <div className = { classes.flexGrow } />
        <div className = { classes.buttonsContainer } >
          { children }
        </div>
      </div>
    </div>

  }
}

export default withStyles(styles)(InfoPageHeader);